import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography as T,
} from "@mui/material";

interface AbandonmentDialogAction {
  label: string;
  callback: () => void;
}

export interface AbandonmentDialogProps {
  open: boolean;
  message: string;
  title: string;
  actions: {
    primary?: AbandonmentDialogAction;
    secondary?: AbandonmentDialogAction;
  };
}

export const ABANDONMENT_DEFAULT = {
  open: false,
  message: "",
  title: "Unsaved Changes",
  actions: {},
};

const AbandonmentDialog = (props: AbandonmentDialogProps) => (
  <Dialog open={props.open} disableEscapeKeyDown maxWidth="xs" transitionDuration={{ exit: 0 }}>
    <DialogTitle>{props.title}</DialogTitle>
    <DialogContent>
      <T>{props.message}</T>
    </DialogContent>
    <DialogActions>
      {props.actions.secondary && (
        <Button variant="outlined" onClick={props.actions.secondary.callback}>
          {props.actions.secondary.label}
        </Button>
      )}
      {props.actions.primary && (
        <Button variant="contained" onClick={props.actions.primary.callback}>
          {props.actions.primary.label}
        </Button>
      )}
    </DialogActions>
  </Dialog>
);

export default AbandonmentDialog;
